import { ScoutFeature } from "../../../Enums/ScoutFeature";

export interface ILoginUserData {
    firstName: string;
    lastName: string;
    initials: string;
    featureAccess: ScoutFeature[];
    userID: number;
}
